// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorBoundary_error__2vjka","button":"ErrorBoundary_button__ZLAm6"};